<template>
    <router-link
      :to="path"
      :disabled="is_disabled"
      :id="id"
      :class="[button_class, 'cursor-pointer p-2 rounded-lg bg-white/30 text-white hover:shadow-lg hover:shadow-white/70 transition-shadow duration-500']"
    >
        <slot></slot>
    </router-link>
  </template>
  
  <script>
  export default {
    props: {
      is_disabled: Boolean,
      button_class: String,
      button_text: String,
      path: String,
      id: String,
    },
  };
  </script>
  